// extracted by mini-css-extract-plugin
export default {"input":"styles-module--input--4QqWs","__invalid":"styles-module--__invalid--gnVs1"};